import { getUserKey } from "utils/getUserKey";

export interface FavoriteApp {
    appId: string;
    name: string;
    orgId: string;
    orgName?: string;
    smallIcon?: string;
}

export function getFavoritesApps(): FavoriteApp[] {
    // eject if there is no localStorage
    if (!localStorage) {
        return [];
    }

    const storageKey = `user-${getUserKey()}-favorites-apps`;
    const storedApps: FavoriteApp[] = localStorage.hasOwnProperty(storageKey)
        ? JSON.parse(localStorage[storageKey])
        : [];

    return storedApps;
}

export function setFavoritesApps(args: FavoriteApp): void {
    // eject if there is no localStorage
    if (!localStorage) {
        return;
    }

    const storedApps = getFavoritesApps();
    const storageKey = `user-${getUserKey()}-favorites-apps`;
    const favoritesApp: FavoriteApp = {
        appId: args.appId,
        name: args.name,
        orgId: args.orgId,
        orgName: args.orgName,
        smallIcon: args.smallIcon
    };

    let mutableApps: FavoriteApp[] = storedApps.filter((storedApp: FavoriteApp) => {
        return storedApp.appId !== args.appId;
    });

    mutableApps = [].concat(favoritesApp, mutableApps).slice(0, 3);
    localStorage.setItem(storageKey, JSON.stringify(mutableApps));
}

export function deleteFromFavoritesApps(app: FavoriteApp): void {
    // eject if there is no localStorage
    if (!localStorage) {
        return;
    }

    const storedApps = getFavoritesApps();
    const storageKey = `user-${getUserKey()}-favorites-apps`;

    let mutableApps: FavoriteApp[] = storedApps.filter(storedApp => {
        return storedApp.appId !== app.appId;
    });

    mutableApps = [].concat(mutableApps).slice(0, 3);
    localStorage.setItem(storageKey, JSON.stringify(mutableApps));
}
